/**
 * Network Status Indicator
 * 
 * Shows network status to users (online/offline, slow connection)
 * Provides visual feedback for network issues
 */

import { AlertCircle, Wifi, WifiOff } from 'lucide-react';
import { useNetworkStatus } from '@/hooks/useNetworkStatus';
import { Alert, AlertDescription } from '@/components/ui/alert';

export function NetworkStatusIndicator() {
  const { isOnline, isSlowConnection } = useNetworkStatus();

  // Don't show anything if online and connection is good
  if (isOnline && !isSlowConnection) {
    return null;
  }

  return (
    <Alert
      variant={isOnline ? 'default' : 'destructive'}
      className="fixed top-4 right-4 z-50 max-w-md shadow-lg"
      aria-live="polite"
    >
      <div className="flex items-center gap-2">
        {isOnline ? (
          <Wifi className="h-4 w-4 shrink-0" aria-hidden />
        ) : (
          <WifiOff className="h-4 w-4 shrink-0" aria-hidden />
        )}
        <AlertDescription>
          {isOnline ? (
            <>Långsam anslutning. Det kan ta längre tid att ladda innehåll.</>
          ) : (
            <>Du är offline. Vissa funktioner kan vara begränsade.</>
          )}
        </AlertDescription>
      </div>
    </Alert>
  );
}
